export class PhoneRequestError extends Error {
  constructor(message: string = 'Не вдалося отримати доступ до номеру телефону') {
    super(message);
    this.name = 'PhoneRequestError';
  }
}
